import React from 'react'


import { TabHeader } from '@containers/Headers/TabHeader'
import { ScreenContainer } from '@containers/ScreenContainer'

import { Header } from './Header/Header'
import { AppInformation } from './InformationComponents/AppInformation'
import { SiteInformation } from './InformationComponents/SiteInformation'
import { Container } from './InformationComponents/styles'
import { UserInformation } from './InformationComponents/UserInformation'
import { SiteSelectionForm } from './SiteSelectionForm/SiteSelectionForm'

export function Profile() {
  return (
    <ScreenContainer header={<TabHeader />}>
      <Container>
        <div>
          <Header />
          <UserInformation />
          <SiteInformation />
          <AppInformation />
        </div>
        <SiteSelectionForm />
      </Container>
    </ScreenContainer>
  )
}
